import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractortransactionFundPaymentCreate = () => {
  const transactionFundPaymentSearch = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/transaction/fund-payment/search', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])
  return { transactionFundPaymentSearch }
}

export default InteractortransactionFundPaymentCreate
